import { useGetLogger } from "@hooks/useGetLogger";
import { useEffect } from "react";
import { MetricName, StreamingFlowMetricDimension } from "@constants/logging";

export const useLogStep = (stepDimension: StreamingFlowMetricDimension) => {
    const logger = useGetLogger();

    useEffect(() => {
        stepDimension &&
            logger.publishMetricWithDimensions(MetricName.STREAMING_FLOW, {
                Step: stepDimension,
            });
    }, [stepDimension]);
};
